//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientGraphQLAuthMutation } from 'Core/data/GraphQLApi';
import { LogManager, ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
import { getLegacyUrl } from 'Core/data/Helpers';
import { v4 as uuidv4 } from 'uuid';

//import { clientGET } from 'Core/data/RestApi';

//action types
import {
	GET_USER_INFO,
	LOGOUT,
	REFRESH_TOKEN,
	GET_ACCESS_ELD_APOLLO,
	CHANGE_SALESFORCE_STATUS,
	SWITCH_ACCOUNT
} from 'Redux/actionTypes';

//actions
import {
	logout,
	getUserInfoResult,
	setIsDeveloper,
	clearRedux,
	refreshTokenResult,
	getSystemPrefResult,
	getAccessEldApolloResult,
	changeSalesForceStatusResult,
	resetALL,
	switchAccountResult,
	getUserInfo
} from 'Redux/actions';

import {
	setCookie,
	eraseCookie
} from 'Core/views/login/helper';

/* FUNCTIONS ASYNC */

function* getUserInfoRequest({ payload }) {
	const { navigate } = payload;
	try {
		let data = yield call(
			clientQuery,
			`{
				User:  getUserInfo {
					... on User {
						avatarFileId
						avatarFile {
							id
							repositoryId
							repositoryType
							repositoryCode
							repositoryPath
							fileKey
							originalName
						}
						username
						subUserId
						companyId
						companyName
						dateformat
						durationFormat
						reportOptions
						siteOptions
						language
						dealerId
						dealerName
						timeZone
						isSubUser
						options
						packageId
						packageName
						createdOn
						unitsCount
						promilesData
						activeTab
						email
						fullName
						accountDataPump
						subuserDataPump
						isKph
						eldUser {
							username
							password
						}
						brandDomains
						tagMode
						tagIds
						zonarIntegration
						users {
							id
							username
							email
							companyId
							registrationStatus
							companyTitle
							isSubUser
							validateUser
						}
						cognitoId
					}
				}
			}
        	`,
			{},
			endpoints.GRAPHQL_GENERAL_V2,
		);

		let dataPref = yield call(
			clientQuery,
			`query getPreference ($projectKey: ProjectKey!, $entityName: EntityName!, $entityId: String!, $preferenceKey: String!) {
				preference: getPreference (projectKey: $projectKey, entityName: $entityName, entityId: $entityId, preferenceKey: $preferenceKey) {
					id
					projectKey
					entityName
					entityId
					preferenceKey
					preferenceValue
				}
			}`,
			{
				"projectKey": "PX",
				"entityName": "System",
				"entityId": "endPoints",
				"preferenceKey": "environments"
			},
			endpoints.GRAPHQL_GENERAL,
		);

		if (data?.User) {

			let isDeveloper = !!((process.env.ENVIROMENT && process.env.ENVIROMENT == "development"));
			yield put(setIsDeveloper(isDeveloper));

			localStorage.setItem("username", data.User?.username)
			sessionStorage.setItem("sessionId", uuidv4())

			yield put(getSystemPrefResult(dataPref?.preference && JSON.parse(dataPref?.preference.preferenceValue)))
			yield put(getUserInfoResult(data.User));

		}
		else
			throw 'not user';

	} catch (exc) {

		ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'getUserInfoRequest');
		yield put(logout(navigate));
		yield put(getUserInfoResult());

	}
}

function* watchGetUserInfoRequest() {
	yield takeEvery(GET_USER_INFO, getUserInfoRequest);
}

function* logoutAsync({ payload }) {
	const { navigate, current_reseller, type_reseller } = payload;
	// duplicate information in a new variable in order to not be clear for the clearRedux("") in the logout
	const newReseller = current_reseller && JSON.parse(JSON.stringify(current_reseller));

	const type = type_reseller && JSON.parse(JSON.stringify(type_reseller));
	
	// Save social media login status before clearing localStorage
	const isSocialMediaLogin = localStorage.getItem('isSocialMediaLogin') === 'true';
	
	const refreshToken = localStorage.getItem('RefreshToken');
	const idToken = localStorage.getItem('IdToken');
	const sessionId = localStorage.getItem('SessionId');
	if (refreshToken && idToken) {
		try {
			yield call(
				clientGraphQLAuthMutation,
				`mutation logoutSession($refreshToken: String!, $idToken: String!, $sessionId: String) {
					logoutSession(
						refreshToken: $refreshToken
						idToken: $idToken
						sessionId: $sessionId
					) {
						success
						message
					}
				}`,
				{
					refreshToken: refreshToken,
					idToken: idToken,
					sessionId: sessionId
				},
				endpoints.GRAPHQL_GENERAL,
			);
		} catch (exc) {
			// Continue with logout even if server logout fails
			ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'logoutAsync - logoutSession');
		}
	}
	try {
		yield put(clearRedux(""));
		yield put(resetALL());
		localStorage.removeItem('AccessToken');
		localStorage.removeItem('RefreshToken');
		localStorage.removeItem('IdToken');
		localStorage.removeItem('username');
		localStorage.removeItem('sm');
		localStorage.removeItem('SessionId');
		localStorage.removeItem('isSocialMediaLogin');
		eraseCookie('GPSTSharedOAUTHToken')
		//localStorage.removeItem('legacyUrl');
		let keys = Object.keys(sessionStorage)
		keys.forEach(key => {
			sessionStorage.removeItem(key)
		})
		
		// Redirect to Cognito logout if it was a social media login
		// if not is a reseller login or if it was a reseller login by key, we redirect to the normal logout
		if (isSocialMediaLogin && (!newReseller || newReseller?.code === 'zonar')) {
			const cognitoDomain = process.env.COGNITO_DOMAIN_USER_POOL_EXTERNAL;
			const clientId = process.env.COGNITO_CLIENT_ID;
			const currentDomain = window.location.origin;
			const logoutUri = encodeURIComponent(`${currentDomain}/login`);
			
			const cognitoLogoutUrl = `${cognitoDomain}logout?client_id=${clientId}&logout_uri=${logoutUri}`;
			window.location.href = cognitoLogoutUrl;
			return;
		}
		
		if (newReseller && type !== 'id') {
			// If the reseller was login by domain or id, we redirect to the normal logout
			if (type === 'key' && newReseller.key) {
				// reseller logout
				navigate(`/reseller/${newReseller.key}`);
			} else {
				// normal logout
				navigate('/login');
			}
		} else if (navigate) {
			navigate('/login');
		}
	} catch (exc) {
		// catch throw
		ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'logoutAsync');
		if (navigate)
			navigate('/login');
	}
}

function* watchLogout() {
	yield takeEvery(LOGOUT, logoutAsync);
}

function* refreshTokenRequest() {
	try {

		const refreshToken = localStorage.getItem('RefreshToken')
		if (!refreshToken) {
			yield put(refreshTokenResult(false));
			return
		}

		let data = yield call(
			clientGraphQLAuthMutation,
			`mutation refreshToken($refreshToken: String!,$sessionId: String) {
				result: refreshToken(refreshToken: $refreshToken,sessionId: $sessionId) {
					AccessToken
					ExpiresIn
					IdToken
					RefreshToken
					
				}
			}`,
			{
				refreshToken: refreshToken,
				sessionId: localStorage.getItem("SessionId")
			},
			endpoints.GRAPHQL_GENERAL,
		);

		if (data && data.result && data.result.authenticationResult) {
			const { authenticationResult } = data.result
			//	token = authenticationResult.IdToken;
			localStorage.setItem('IdToken', authenticationResult.IdToken);
			setCookie("GPSTSharedOAUTHToken", authenticationResult.IdToken, 1)
			localStorage.setItem('AccessToken', authenticationResult.AccessToken);
			authenticationResult.RefreshToken = localStorage.getItem("RefreshToken")

			yield put(refreshTokenResult(true));
		}
		else
			throw 'Error refresh token';

	} catch (exc) {

		ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'refreshTokenRequest');
		yield put(refreshTokenResult(false));

	}
}

function* watchRefreshToken() {
	yield takeEvery(REFRESH_TOKEN, refreshTokenRequest);
}

function* getAccessEldApollo({ payload }) {
	const { username, password } = payload
	try {

		let QUERY = `
            query getEldAccess ($eldUser: EldUserInput) {
                result: getEldAccess (eldUser: $eldUser) {
                    access
                }
            }
        `

		const response = yield call(
			clientQuery,
			QUERY,
			{
				eldUser: {
					username,
					password
				}
			},
			endpoints.GRAPHQL_GENERAL,
		);

		yield put(getAccessEldApolloResult(response?.result?.access))

	} catch (exc) {
		yield put(getAccessEldApolloResult(null))
		ExceptionManager(
			exc,
			"Core/containers/Auth/redux/saga",
			"getAccessEldApollo"
		);
	}
}

function* watchAccessEldApollo() {
	yield takeEvery(GET_ACCESS_ELD_APOLLO, getAccessEldApollo);
}

function* changeSalesForceStatus({ payload }) {
	try {
		const element = document.getElementsByClassName('showDockableContainer')
		if (!element[0]?.style) return
		if (!payload) {
			element[0].style.display = 'none';
		} else {
			element[0].style.display = 'flex';
		}

		yield put(changeSalesForceStatusResult(!payload))

	} catch (exc) {
		yield put(changeSalesForceStatusResult(payload))
		ExceptionManager(
			exc,
			"Core/containers/Auth/redux/saga",
			"changeSalesForceStatus"
		);
	}
}

function* watchChangeSalesForceStatus() {
	yield takeEvery(CHANGE_SALESFORCE_STATUS, changeSalesForceStatus);
}

function* switchAccountRequest({ payload }) {
	const { authId, cognitoId, navigate } = payload;
	try {
		const refreshToken = localStorage.getItem('RefreshToken');
		const sessionId = localStorage.getItem('SessionId');
		
		if (!refreshToken) {
			yield put(switchAccountResult(false, 'No refresh token found'));
			return;
		}

		let data = yield call(
			clientGraphQLAuthMutation,
			`mutation refreshToken($refreshToken: String!, $sessionId: String, $authId: String, $sub: String) {
				result: refreshToken(
					refreshToken: $refreshToken
					sessionId: $sessionId
					authId: $authId
					sub: $sub
				) {
					
					AccessToken
					ExpiresIn
					IdToken
					RefreshToken
					SessionId
				
				}
			}`,
			{
				refreshToken,
				authId,
				sub: cognitoId
			},
			endpoints.GRAPHQL_GENERAL,
		);

		if (data && data.result) {
			const { IdToken, AccessToken, RefreshToken, SessionId } = data.result;
			// Update tokens
			localStorage.setItem('IdToken', IdToken);
			setCookie('GPSTSharedOAUTHToken', IdToken, 1);
			localStorage.setItem('AccessToken', AccessToken);
			localStorage.setItem("SessionId", SessionId);
			if (RefreshToken) {
				localStorage.setItem('RefreshToken', RefreshToken);
			}

			yield put(switchAccountResult(true, null));
			
			// Refresh user info and reload the page
			// yield put(getUserInfo(navigate));
			
			// Give a moment for the store to update, then reload
			yield put(clearRedux(""));
			yield put(clearRedux('REALTIME'));
			yield put(resetALL(""));
			setTimeout(() => {
				
				window.location.reload();
			}, 500);
		} else {
			throw new Error('Failed to switch account');
		}
	} catch (exc) {
		ExceptionManager(exc, 'Core/containers/Auth/redux/saga', 'switchAccountRequest');
		yield put(switchAccountResult(false, 'Failed to switch account'));
	}
}

function* watchSwitchAccount() {
	yield takeEvery(SWITCH_ACCOUNT, switchAccountRequest);
}

//MERGE SAGA
export default function* rootSaga() {
	yield all([
		fork(watchGetUserInfoRequest),
		fork(watchLogout),
		fork(watchRefreshToken),
		fork(watchAccessEldApollo),
		fork(watchChangeSalesForceStatus),
		fork(watchSwitchAccount),
	]);
}
